import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store/index'

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import './components/auto_register' // 全局公共组件
import  './assets/styles/common.less'; // 引入公共样式文件
import enums from './utils/enums' // 全局枚举管理
import * as common from './utils/common' // 全局公共方法
import moment from 'moment'
Vue.prototype.$enums = enums
Vue.prototype.$moment = moment
Vue.config.productionTip = false
Vue.use(ElementUI)

Object.keys(common).forEach(key => {
  Vue.prototype[`$${key}`] = common[key]
})
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App)
})
